import { render, staticRenderFns } from "./LastPlayerButtonWrapper.vue?vue&type=template&id=81808b08&scoped=true&"
import script from "./LastPlayerButtonWrapper.vue?vue&type=script&lang=ts&"
export * from "./LastPlayerButtonWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./LastPlayerButtonWrapper.vue?vue&type=style&index=0&id=81808b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81808b08",
  null
  
)

export default component.exports